import React, { PropTypes } from "react";
import Accordion from "../components/common/Accordion";
import axios from "axios";
import LoadingSpinner from "../feature/loadingSpinner";

class MyPolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      src: null,
      policyGroups: [],
      loading: true,
      policies: [],
    };
  }

  componentDidMount() {
    let request = {
      type: "1"
    };

    axios
      .get(
        process.env.REQ_URL +
          "/policies/getPoliciesAndGroups?q=" +
          JSON.stringify(request),
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      )
      .then(response => {
        this.setState({ policyGroups: response.data.data, loading: false });
      })
      .catch(error => {
        console.log(
          "error while calling api /policies/getPoliciesAndGroups" + error
        );
      });
  }

  refresh() {
      let request = {
          type: "1"
      };

      axios
          .get(
              process.env.REQ_URL +
              "/policies/getPoliciesAndGroups?q=" +
              JSON.stringify(request),
              {
                  withCredentials: true,
                  headers: { "X-Requested-With": "XMLHttpRequest" }
              }
          )
          .then(response => {
              this.setState({ policyGroups: response.data.data, loading: false });
          })
          .catch(error => {
              console.log(
                  "error while calling api /policies/getPoliciesAndGroups" + error
              );
          });
  }

  accordSelect(index) {
    this.setState({
      accordSelected: index
    });
  }

  renderAccordion() {
    const data = this.state.policyGroups;
    return data.map((group, index) => {
      return (
        <Accordion
          key={index}
          header={group.value}
          groupId={group.id}
          classHead={
            this.state.accordSelected == group.id
              ? "accordion_heading accord_active"
              : "accordion_heading"
          }
          onClickhead={() => this.accordSelect(group.id)}
          policy={this.state.policies}
          vertical={this.props.vertical}
          department = {this.props.department}
        />
      );
    });
  }

  render() {
    return (
      <div>
        <div className="tabContent">
          {this.state.loading ? <LoadingSpinner /> : this.renderAccordion()}
        </div>
      </div>
    );
  }
}

MyPolicy.proptypes = {};

export default MyPolicy;



/** WEBPACK FOOTER **
 ** ./src/components/myPolicy.js
 **/